import { Box } from "@mui/material";

function NotFound() {
  return (
    <Box
      sx={{
        height: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h2>404 NotFound</h2>
    </Box>
  );
}

export default NotFound;
